import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'TrendParagraph',
  props: {
    initialColor: {
      type: String,
      default: '#3C3C3B'
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    buttonColor: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    buttonUrl: {
      type: String,
      required: true
    },
    quote: {
      type: String,
      default: ''
    }
  },
  computed: {
    initial: function initial() {
      return this.title.charAt(0).toUpperCase();
    }
  }
};